export function copy(list) {
  return JSON.parse(JSON.stringify(list));
}

export function depedency(data) {
  return copy(data).filter(item => item['camp_seq_parent'] !== 0).map((item) => {
    let newItem = {};
    newItem.predecessorId = item['camp_seq_parent'];
    newItem.successorId = item['camp_seq'];
    newItem.type = 3;
    newItem.id = item['camp_seq'];
    return newItem;
  });
}

export function stringify(data) {
  let copyData = copy(data);
  return copyData.map((item) => {
    for (var prop in item) {
      if (typeof item[prop] === 'boolean') item[prop] = String(item[prop]);
      else if (item[prop] === null) item[prop] = '';
    }
    item.children = undefined;
    item.id = item['camp_seq'];
    item.start = new Date(item['camp_dt_deb']);
    item.end = new Date(item['camp_dt_fin']);
    item.title = item['camp_descr'];
    item.color = item.color === '' ? 'rgb(32,99,155)' : item.color;
    item.parentId =
      item['camp_seq_parent'] === 0 ? undefined : item['camp_seq_parent'];
    if (item.parentId !== 0) {
      let parentExist = data.some((x) => x.camp_seq === item.parentId);
      if (!parentExist) item.parentId = undefined;
    }
    if (item['camp_seq_parent'] !== 0) {
      let currentItem = copyData.find(d => d["camp_seq"] === item["camp_seq_parent"]);
      if (currentItem) {
        currentItem.children = currentItem.children ? currentItem.children : [];
        currentItem.children.push(item);
      }
    }
    return item;
  }).filter(d => d["camp_seq_parent"] === 0 || !copyData.find(c => c["camp_seq"] === d["camp_seq_parent"]));
}
